import { Injectable } from "@angular/core";

// system-health.service.ts
@Injectable({ providedIn: "root" })
export class SystemHealthService {
  private readonly KEY = "SYSTEM_DOWN";
  private readonly TTL = 2 * 60 * 1000;

  markDown() {
    localStorage.setItem(this.KEY, Date.now().toString());
  }

  clear() {
    localStorage.removeItem(this.KEY);
  }

  isDown(): boolean {
    const time = localStorage.getItem(this.KEY);
    if (!time) return false;

    return Date.now() - +time < this.TTL;
  }
}
